import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { translate } from 'components/Translation';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import BillingAccountsList from 'views/ActiveServices/BillingAccountsList';
import Details from 'views/ActiveServices/Details';

interface IProps extends RouteComponentProps {}

const ActiveServices = (props: IProps) => {
	return (
		<>
			<BreadcrumbsItem to="/dashboard/active-services">
				{`${translate('path.my.services')} - ${translate('path.my.active.services')}`}
			</BreadcrumbsItem>
			<Switch>
				<Route path={`${props.match.path}`} exact render={(props: any) => <BillingAccountsList {...props} />} />
				<Route
					path={`${props.match.path}/:billingId([0-9][0-9]*)/:accountId([0-9][0-9]*)/:subpage?`}
					render={(props: any) => <Details {...props} />}
				/>
			</Switch>
		</>
	);
};

export default ActiveServices;
